import { render, staticRenderFns } from "./Promo3MFF.vue?vue&type=template&id=e17541c0&scoped=true"
var script = {}
import style0 from "./Promo3MFF.vue?vue&type=style&index=0&id=e17541c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.28_css-loader@6.11.0_webpack@5.105.2__lodash@4_64be4d9407eb667fe9a1e2476327747d/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e17541c0",
  null
  
)

export default component.exports